var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Page", {
        attrs: { title: _vm.pageTitle, isFullWidth: true },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "Polaris-Page-Header__PrimaryActionWrapper" },
                  [
                    _c(
                      "div",
                      { staticClass: "Polaris-Box Polaris-Box--printHidden" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "Polaris-Button Polaris-Button--primary",
                            attrs: { type: "button", disabled: _vm.isLoading },
                            on: { click: _vm.refreshCurrentPage }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "Polaris-Button__Content" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "Polaris-Button__Text" },
                                  [
                                    _vm._v("Refresh"),
                                    _vm.isLoading
                                      ? _c("span", [_vm._v("ing")])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col max-w-7xl mx-auto my-10" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
                      },
                      [
                        _vm.isLoading
                          ? _c("div", [_c("Spinner")], 1)
                          : _vm._e(),
                        _c("div", { staticClass: "flex flex-col" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "align-middle inline-block min-w-full shadow  sm:rounded-lg border-b border-gray-200 mb-24"
                                },
                                [
                                  _c("div", { staticClass: "Polaris-Card" }, [
                                    _c("div", {}, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "Polaris-DataTable__Navigation"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "Polaris-Button Polaris-Button--disabled Polaris-Button--plain Polaris-Button--iconOnly",
                                              attrs: {
                                                "aria-label":
                                                  "Scroll table left one column",
                                                "aria-disabled": "true",
                                                type: "button",
                                                tabindex: "-1"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "Polaris-Button__Content"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "Polaris-Button__Icon"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "Polaris-Icon"
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                                          }),
                                                          _c(
                                                            "svg",
                                                            {
                                                              staticClass:
                                                                "Polaris-Icon__Svg",
                                                              attrs: {
                                                                viewBox:
                                                                  "0 0 20 20",
                                                                focusable:
                                                                  "false",
                                                                "aria-hidden":
                                                                  "true"
                                                              }
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  d:
                                                                    "M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293a.999.999 0 0 1-.707 1.707z"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "Polaris-Button Polaris-Button--plain Polaris-Button--iconOnly",
                                              attrs: {
                                                "aria-label":
                                                  "Scroll table right one column",
                                                type: "button"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "Polaris-Button__Content"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "Polaris-Button__Icon"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "Polaris-Icon"
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                                          }),
                                                          _c(
                                                            "svg",
                                                            {
                                                              staticClass:
                                                                "Polaris-Icon__Svg",
                                                              attrs: {
                                                                viewBox:
                                                                  "0 0 20 20",
                                                                focusable:
                                                                  "false",
                                                                "aria-hidden":
                                                                  "true"
                                                              }
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  d:
                                                                    "M8 16a.999.999 0 0 1-.707-1.707l4.293-4.293-4.293-4.293a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5a.997.997 0 0 1-.707.293z"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "Polaris-DataTable Polaris-DataTable__ShowTotals overflow-auto"
                                        },
                                        [
                                          _c("div", {}, [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "Polaris-DataTable__Table"
                                              },
                                              [
                                                _c("thead", [
                                                  _c(
                                                    "tr",
                                                    {
                                                      staticClass:
                                                        "hidden md:table-row"
                                                    },
                                                    [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [_vm._v(" Subscriber ")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [_vm._v(" Browser ")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [_vm._v(" OS ")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Device Used "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [_vm._v(" Date ")]
                                                      )
                                                    ]
                                                  )
                                                ]),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.subscribers.docs,
                                                    function(subscriber) {
                                                      return _c(
                                                        "SubscriberItem",
                                                        {
                                                          key: subscriber.id,
                                                          attrs: {
                                                            subscriber: subscriber,
                                                            "shop-origin":
                                                              _vm.shopOrigin
                                                          }
                                                        }
                                                      )
                                                    }
                                                  ),
                                                  1
                                                )
                                              ]
                                            )
                                          ]),
                                          _c("Pagination", {
                                            attrs: { page: _vm.subscribers },
                                            on: { pageChanged: _vm.loadPage }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              !_vm.isLoading &&
                              _vm.subscribers.docs &&
                              _vm.subscribers.docs.length === 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                                    },
                                    [
                                      _vm._v(
                                        " You don't have any subscribers right now. We will be listing them here as soon as customer is subscribed. "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }